import React, { FC } from 'react'

import GlobalStyle from 'styles/global'
import { Container, DetailCard } from './styled'

const MaintenancePage: FC = ({ children }) => {
  const maintenanceWindow = process.env.GATSBY_MAINTENANCE_WINDOW

  if (!maintenanceWindow || Number(maintenanceWindow) < 1) {
    return <div>{children}</div>
  }

  return (
    <div>
      <GlobalStyle />
      <Container>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          height="30%"
          viewBox="0 0 128 291"
        >
          <path
            fill="#B38D44"
            d="M64.383 102.009c-.0137 0-.0277.001-.0418.001-7.0748.178-12.3748 6.551-11.2872 13.54 2.0548 13.2 1.3167 27.775.6328 41.281-.3224 6.368-.6328 12.497-.6328 18.133 0 31.907 9.6445 44.984 17.9503 56.245 6.2809 8.515 11.7962 15.993 11.7962 29.791.0048.01.0098.019.0151.028.0866 3.004-2.2163 4.554-4.4598 6.064-.0515.035-.1029.069-.1543.104-2.2306 1.503-4.1639 3.319-5.8002 5.451-2.4704 3.221-3.9003 6.873-4.4761 10.876-.2163 1.507-.363 3.018-.2174 4.538.0381.399.1027.8.1971 1.193.2578 1.076 1.3059 1.565 2.2709 1.026.196-.11.3833-.235.5514-.377.5931-.502 1.1736-1.025 1.7181-1.58 1.7535-1.787 3.7691-3.316 6.086-4.263 2.3256-.952 4.7644-1.467 7.208-1.969 1.4877-.305 2.9491-.709 4.2719-1.502.8766-.525 1.667-1.153 2.3176-1.939 1.6191-1.957 2.1035-4.213 1.3634-6.609-.0574-.185-.1371-.397-.2185-.612-.2386-.633-.4909-1.301-.2317-1.45.2567-.146.5091.333.6309.564.0151.029.0282.054.0391.073 1.7826 3.177 4.4856 5.246 7.837 6.54 4.421 1.708 9.266 1.408 13.825.512l.3-.06c1.763-.347 3.544-.698 5.348-.671.948.014 1.894.137 2.809.393.281.079.559.18.838.281.6.217 1.201.435 1.843.437.201 0 .409-.024.578-.131.926-.584.156-2.583-.172-3.292-3.16-6.855-10.409-11.331-17.443-13.418-.521-.155-1.049-.292-1.576-.428-.114-.03-.227-.059-.34-.089-2.767-.703-5.54-1.379-8.3127-2.055-1.1394-.278-2.2788-.556-3.4178-.836-1.8419-.452-4.0647-1.436-5.5812-2.927-3.6948-8.987-1.3596-16.83 1.7199-27.172 2.5319-8.503 5.5669-18.695 6.1672-32.603.2416-5.597 1.3337-8.516 1.3337-8.516l.0997-.625c2.4112 4.859 3.5402 7.166 4.1282 8.368.498 1.02.609 1.245.783 1.558.254.456.697 1.074 1.169 1.083.397.007.95-.778 1.299-1.275.065-.093.123-.175.172-.241.084-.113.162-.232.233-.352.582-.989.949-2.064 1.273-3.158.605-2.032.598-3.735.395-5.847-.255-2.654-1.021-5.872-1.937-8.357-.439-1.189-1.403-3.117-2.34-4.99-1.154-2.308-2.266-4.531-2.298-5.18-.005-.121.004-.668.018-1.521.061-3.568.211-12.484-.274-17.894-.019-.214-.039-.429-.058-.645-1.227-13.741-2.7971-31.323-16.0008-39.21-6.5474-3.911-14.2993-6.448-21.8965-6.287-.0164 0-.0334.001-.0507.001z"
          />
          <path
            fill="#000"
            fillRule="evenodd"
            d="M76.5208 148.209c.4212-2.147.2878-4.978-1.9682-7.821-.3433-.433-.2708-1.062.1618-1.405.4326-.343 1.0617-.271 1.4049.162 2.6964 3.398 2.872 6.861 2.3641 9.449-.252 1.284-.6707 2.352-1.0263 3.101a11.724 11.724 0 01-.4638.881 8.089 8.089 0 01-.1481.243 2.0261 2.0261 0 01-.0443.068l-.0136.021-.0045.006-.0017.003-.0007.001c-.0003 0-.0006.001-.8264-.563l.8258.564c-.3115.456-.9337.573-1.3898.262-.4554-.311-.573-.932-.2632-1.388.0001 0-.0002 0 0 0l.0006-.001.0042-.006c.005-.008.0138-.021.026-.041.0244-.038.0622-.099.1101-.181.096-.163.2321-.41.3828-.727.3024-.637.6577-1.545.8703-2.628z"
            clipRule="evenodd"
          />
          <path
            fill="#000"
            d="M15.699 180.074c-1.2377-29.78 10.7058-51.319 30.6587-52.486l1.4744 35.477c-7.8092.324-19.3181 20.223-19.7734 37.055-.6099 22.548 3.0388 20.153.7837 24.034-10.029-.271-12.0847-18.605-13.1434-44.08z"
          />
          <mask
            id="a"
            width="38"
            height="98"
            x="13"
            y="127"
            maskUnits="userSpaceOnUse"
          >
            <path
              fill="#C6D3DE"
              d="M15.7009 180.075c-1.2376-29.781 10.7058-51.32 30.6587-52.487l1.4745 35.477c-7.8092.325-19.3181 20.223-19.7734 37.056-.61 22.548 3.0388 20.152.7837 24.034-10.0291-.272-12.0847-18.606-13.1435-44.08z"
            />
          </mask>
          <g fill="#B38D44" mask="url(#a)">
            <path d="M32.0252 133.8l2.2668.634.0978 2.352 1.3032-1.96 2.2669.634-1.4614-1.846 1.3033-1.96-2.2065.82-1.4614-1.845.0977 2.352-2.2064.819zM24.1697 139.8l2.2669.634.0977 2.352 1.3033-1.96 2.2668.633-1.4614-1.845 1.3033-1.96-2.2065.82-1.4614-1.845.0978 2.351-2.2065.82zM32.5291 145.937l2.2668.634.0978 2.352 1.3032-1.96 2.2669.634-1.4614-1.846 1.3033-1.96-2.2065.82-1.4614-1.845.0977 2.352-2.2064.819zM16.3123 145.802l2.2668.633.0978 2.352 1.3032-1.96 2.2669.634-1.4614-1.845 1.3033-1.96-2.2065.819-1.4614-1.845.0977 2.352-2.2064.82zM16.0076 157.973l2.2669.634.0977 2.352 1.3033-1.96 2.2668.633-1.4614-1.845 1.3033-1.96-2.2065.82-1.4614-1.845.0977 2.351-2.2064.82zM24.6736 151.938l2.2669.634.0977 2.352 1.3033-1.96 2.2668.634-1.4614-1.846 1.3033-1.96-2.2065.82-1.4614-1.845.0978 2.352-2.2065.819zM32.9353 155.649l2.2669.634.0977 2.352 1.3033-1.96 2.2669.633-1.4614-1.845 1.3032-1.96-2.2065.82-1.4614-1.845.0978 2.351-2.2065.82zM25.1795 164.078l2.2668.633.0978 2.352 1.3032-1.96 2.2669.634-1.4614-1.845 1.3033-1.96-2.2065.819-1.4614-1.845.0977 2.352-2.2064.82zM16.4783 169.303l2.2669.634.0977 2.352 1.3033-1.96 2.2668.634-1.4614-1.846 1.3033-1.96-2.2065.82-1.4614-1.845.0977 2.352-2.2064.819zM25.6502 175.406l2.2668.634.0978 2.351 1.3032-1.96 2.2669.634-1.4614-1.845 1.3033-1.96-2.2065.82-1.4614-1.846.0977 2.352-2.2064.82zM34.1072 170.272l2.2669.634.0977 2.352 1.3033-1.96 2.2668.634-1.4614-1.846 1.3033-1.96-2.2065.82-1.4614-1.845.0978 2.352-2.2065.819zM41.7341 179.797l2.2669.634.0978 2.352 1.3032-1.961 2.2669.634-1.4614-1.845 1.3032-1.96-2.2064.82-1.4614-1.845.0977 2.351-2.2065.82zM17.117 181.422l2.2668.634.0978 2.352 1.3032-1.96 2.2669.633-1.4614-1.845 1.3033-1.96-2.2065.82-1.4614-1.845.0977 2.352-2.2064.819zM9.2634 187.422l2.2669.634.0978 2.352 1.3032-1.961 2.2669.634-1.4614-1.845 1.3032-1.96-2.2064.82-1.4614-1.845.0977 2.351-2.2065.82zM24.2732 189.36l2.2669.634.0977 2.351 1.3033-1.96 2.2669.634-1.4615-1.845 1.3033-1.96-2.2065.819-1.4614-1.845.0978 2.352-2.2065.82zM9.7654 199.56l2.2669.634.0977 2.352 1.3033-1.96 2.2668.633-1.4614-1.845 1.3033-1.96-2.2065.82-1.4614-1.845.0978 2.351-2.2065.82zM10.2713 211.699l2.2668.634.0978 2.352 1.3032-1.96 2.2669.634-1.4614-1.846 1.3033-1.96-2.2065.82-1.4614-1.845.0977 2.352-2.2064.819zM10.742 223.028l2.2668.634.0978 2.352 1.3032-1.961 2.2669.634-1.4614-1.845 1.3033-1.96-2.2065.82-1.4614-1.846.0977 2.352-2.2064.82zM24.1365 213.506l2.2669.634.0977 2.352 1.3033-1.961 2.2668.634-1.4614-1.845 1.3033-1.96-2.2065.82-1.4614-1.845.0978 2.351-2.2065.82zM26.8279 227.419l2.2669.634.0977 2.351 1.3033-1.96 2.2668.634-1.4614-1.845 1.3033-1.96-2.2065.82-1.4614-1.846.0978 2.352-2.2065.82zM38.365 224.864l2.2669.634.0977 2.351 1.3033-1.96 2.2669.634-1.4615-1.845 1.3033-1.96-2.2065.82-1.4614-1.846.0978 2.352-2.2065.82zM22.4509 203.646l2.2669.634.0978 2.352 1.3032-1.96 2.2669.634-1.4614-1.846 1.3032-1.96-2.2064.82-1.4614-1.845.0977 2.352-2.2065.819zM14.7869 195.554l2.2668.634.0978 2.352 1.3033-1.96 2.2668.634-1.4614-1.846 1.3033-1.96-2.2065.82-1.4614-1.845.0977 2.352-2.2064.819z" />
            <path d="M15.1541 208.466l2.2668.634.0978 2.352 1.3032-1.96 2.2669.634-1.4614-1.845 1.3033-1.961-2.2065.82-1.4614-1.845.0977 2.352-2.2064.819z" />
          </g>
          <path
            fill="#fff"
            d="M45.4197 123.791c-.6707.415-1.0613 1.15-1.1309 1.935-1.2123 13.69 4.8144 20.429.5821 39.815-.238 1.089.4317 2.191 1.5319 2.374 2.5447.423 4.5945.376 7.258-.152.708-.14 1.2704-.678 1.4686-1.372 4.4517-15.584 4.8883-26.795-.0029-42.687-.1979-.643-.7112-1.154-1.3712-1.284-3.0572-.602-6.0139-.063-8.3356 1.371zM28.9997 217l2.5734 6.236 5.5362-3.855-1.2062 6.637 6.741-.249-4.6029 4.931 5.8058 3.435-6.5383 1.66 3.0272 6.028-6.3978-2.139-.7124 6.708-4.226-5.258-4.226 5.258-.7125-6.708-6.3978 2.139 3.0272-6.028-6.5383-1.66 5.8059-3.435-4.603-4.931 6.7411.249-1.2062-6.637 5.5361 3.855L28.9997 217z"
          />
          <circle
            cx="109.232"
            cy="51.2326"
            r="10.5"
            fill="#E1E9EF"
            transform="rotate(10.466 109.232 51.2326)"
          />
          <path
            fill="#B38D44"
            d="M111.59 57.5222l.432-2.3389-3.326-.6143 4.421-5.3176.399-2.1558-6.58-1.2155-.433 2.339 3.593.6637-4.764 5.6768-.322 1.7472 6.58 1.2154z"
          />
          <circle
            cx="60.1661"
            cy="69.167"
            r="13.5"
            fill="#E1E9EF"
            transform="rotate(7.6 60.1661 69.167)"
          />
          <path
            fill="#B38D44"
            d="M63.6659 76.9676l.4314-3.2327-4.5082-.6016 5.6022-7.5969.3976-2.9795-8.9209-1.1904-.4314 3.2326 4.8712.65-6.0406 8.1133-.3222 2.4148 8.9209 1.1904z"
          />
          <circle
            cx="35.3788"
            cy="20.3794"
            r="17.5"
            fill="#E1E9EF"
            transform="rotate(-8.797 35.3788 20.3794)"
          />
          <path
            fill="#B38D44"
            d="M44.0095 30.3771l-.7444-4.8106-6.9918 1.082 5.1036-13.2823-.6861-4.4339-13.8353 2.1412.7445 4.8106 7.5546-1.1692-5.5365 14.2099.5561 3.5934 13.8353-2.1411z"
          />
          <circle
            cx="84.2415"
            cy="72.2415"
            r="3"
            fill="#E1E9EF"
            transform="rotate(-46.342 84.2415 72.2415)"
          />
          <circle
            cx="86.952"
            cy="42.3185"
            r="5.3261"
            fill="#E1E9EF"
            transform="rotate(-46.342 86.952 42.3185)"
          />
          <circle
            cx="65.0417"
            cy="19.4033"
            r="4.1586"
            fill="#E1E9EF"
            transform="rotate(-46.342 65.0417 19.4033)"
          />
          <circle
            cx="102.179"
            cy="28.26"
            r="4.3565"
            fill="#E1E9EF"
            transform="rotate(-46.342 102.179 28.26)"
          />
          <circle
            cx="91.6553"
            cy="90.6553"
            r="4"
            fill="#E1E9EF"
            transform="rotate(-46.342 91.6553 90.6553)"
          />
          <circle
            cx="9.4064"
            cy="37.2462"
            r="3.7107"
            fill="#E1E9EF"
            transform="rotate(-46.342 9.4064 37.2462)"
          />
          <circle
            cx="52.8975"
            cy="28.9436"
            r="5.5859"
            fill="#E1E9EF"
            transform="rotate(-46.342 52.8975 28.9436)"
          />
        </svg>
        <DetailCard>
          <h1>Shh.. we’re sleeping. Come back later.</h1>
          <p>
            We’re doing routine maintanence on our site right now. Try again in{' '}
            {maintenanceWindow} minutes.
          </p>
          <p>
            Contact us at{' '}
            <a href="mailto:support@meetfellow.com">support@meetfellow.com</a>{' '}
            if we can help you with anything in the meantime.
          </p>
          <p>And yes... sperm whales sleep vertically!</p>
        </DetailCard>
      </Container>
    </div>
  )
}

export default MaintenancePage
